import UserModel from "../../User/Domain/User.model";
import {GetDeliveryInfoService, GetCollectsBetweenDatesService} from "../Infrastructure/Delivery.service";

export async function GetDeliveryInfoLogic(id) {
  try {
    const { data } = await GetDeliveryInfoService(id);
    return {
      valid: true,
      info: new UserModel(
        data.item.id,
        "delivery",
        data.item.email,
        data.item.name,
        data.item.lastName,
        data.item.sex,
        data.item.address,
        data.item.age,
        data.item.phone,
        data.item.profilePicture,
      ),
    };
  } catch (error) {
    if (error.response)
      return { valid: false, info: error.response.data.error };
    return { valid: false, info: error.message };
  }
}

export async function GetCollectsLogic(data){
  return GetCollectsBetweenDatesService(data);
}